export const environment = {
  production: false,
  webshopId: 'ab207ef9-d1e3-4232-a91d-f3917015bbfb', // Placeholder, pas aan indien nodig
  apiUrl: 'https://dev-api.genydev.nl', // Placeholder API URL
  language: 'NL',
  license: 'eyJpZCI6IjAyZmEyNjA4LWFiZjgtNGZkMy1iMmNiLWNmOTI4MWI5M2JmNyIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODU0MzQ5OTgsImV4cCI6MTgxNjk3MDk5OH0.GAOgVuplsik-_Dc897VgdagnNeUpiiqC2gVSoUALROgLI0A4FTpxytUL9obUCg4PWU1C1wzcWTFYtQ881LfMCg'
};
